export enum OpenBankingTransactionType {
  BankTransfer = 'BankTransfer',
  Card = 'Card',
  CashWithdrawal = 'CashWithdrawal',
  DirectDebit = 'DirectDebit',
  InternalCounterEntry = 'InternalCounterEntry',
  PeerToPeer = 'PeerToPeer',
  Unknown = 'Unknown',
}
